
import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    userId = '',
    admin = false,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.org.myOrgAddUser, {
        userId,
        admin,
    }, options);
    if (error) return { error, status };
    return content || {};
};
